import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import './BookAppointment.css';
import clinicPhoto from '../../assets/Baby/book.jpg';
import { API_BASE } from '../../api';

const BookAppointment = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    message: ''
  });

  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loading) return; // prevent multiple clicks

    setLoading(true);
    setError('');

    try {
      const response = await fetch(
        `${API_BASE}/appointments`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setIsSubmitted(true);

        setFormData({
          name: '',
          email: '',
          phone: '',
          date: '',
          message: '',
        });
      } else {
        setError(data.message || 'Submission failed');
      }
    } catch (err) {
      setError('Server error. Please try again later.');
    }

    // small delay so "Submitting..." is visible
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  return (
    <div className="book-appointment-container">

      {/* SEO */}
      <Helmet>
        <title>Book IVF Appointment in Ambala | Free Consultation | Amaanat IVF</title>

        <meta
          name="description"
          content="Book your IVF consultation in Ambala at Amaanat IVF Clinic. Get expert fertility advice, high success treatments, and personalized care."
        />

        <link rel="canonical" href="https://amaanativf.com/bookappointment" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "name": "Amaanat IVF",
            "url": "https://amaanativf.com/bookappointment",
            "potentialAction": {
              "@type": "ReserveAction",
              "target": "https://amaanativf.com/bookappointment",
              "result": {
                "@type": "Reservation",
                "name": "IVF Consultation Booking"
              }
            },
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Ambala",
              "addressCountry": "India"
            }
          })}
        </script>
      </Helmet>

      <div className="book-appointment">
        <div className="appointment-content">

          {/* Image */}
          <div className="appointment-image">
            <img
              src={clinicPhoto}
              alt="Book IVF Appointment in Ambala Clinic"
              loading="lazy"
            />
          </div>

          {/* Form */}
          <div className="appointment-form-wrapper">

            {isSubmitted ? (
              <div className="appointment-success">
                <div className="success-icon">✅</div>
                <h3>Appointment Booked Successfully!</h3>
                <p>Our IVF team will contact you within 24 hours.</p>
              </div>
            ) : (

              <form className="appointment-form" onSubmit={handleSubmit}>

                <h1>Book Free IVF Consultation in Ambala</h1>

                <div className="form-group">
                  <input
                    type="text"
                    name="name"
                    placeholder="Full Name *"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="form-row">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address *"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone Number *"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <input
                    type="date"
                    name="date"
                    value={formData.date}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <textarea
                    name="message"
                    placeholder="Any IVF concerns? (optional)"
                    value={formData.message}
                    onChange={handleInputChange}
                    rows="4"
                  />
                </div>

                {error && <p className="form-error">{error}</p>}

                {/* ✅ UPDATED BUTTON */}
                <button
                  type="submit"
                  disabled={loading}
                  className={loading ? 'loading' : ''}
                >
                  {loading ? (
                    <>
                      <span className="spinner"></span> Submitting...
                    </>
                  ) : (
                    'Book Appointment Now'
                  )}
                </button>

              </form>
            )}

          </div>
        </div>
      </div>
    </div>
  );
};

export default BookAppointment;